<script src="https://code.jquery.com/jquery-1.12.3.min.js"></script>


<script src="https://cdnjs.cloudflare.com/ajax/libs/jspdf/0.9.0rc1/jspdf.min.js"></script>
<script> 
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import { jsPDF } from "jspdf";
//import html2canvas from "html2canvas"
  


export default {
  mixins: [apibtoast, apigeneric],
  props: ["guncelle", "satdosyaId"],
  data() {
    return {

      KurumBilgisi :[],
      ihale_komisyonu: [],
      OnayBelgesi:{},
      ihale_usulu:"",
      alim_turu:"",
      ihaleilani:[],
      Firma_Toplam:[],
      zarfacmakontrol:{},
      gecerli_teklifler:[],
      gecersiz_teklifler:[],
      dosyafirmalar:[],
      harcamayetkilisi:{},
      katilanfirmalar:0,
      dipnot1:'Standart Form --- KİK019.0/',
      dipnot2:'İhale Komisyonu Kararı',
      Ihalekomisyonkararitarihi:"",
      Dokumansatinalanlarinsayisi:"",
      Ihalekomisyonkarari:"",
    

      Dosya:{},
          Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

         uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
 

    };
  },

  components: {
    Loader

 
  },
  watch: {
    guncelle() {
      this.Get();     
    },
  },
created(){
    this.Get();
  },
  methods: {



      ExcelExport(table, name){ 
          if (!table.nodeType) table = this.$refs.KomisyonKarari
          var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
         var a = document.createElement('a');
       a.href = this.uri +this.base64(this.format(this.template, ctx));
        a.download = name + '.xls';
        a.click(); 
      }, 

    Get() {

          this.ActionsFilterGet({
          Service: "SatDosyaFirma",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.satdosyaId ,
          }).then((res) => {

              this.dosyafirmalar=res.Data;

          });


           this.teklifkontrol();



      this.ActionsGet({"Service":"OKurumSabit", "Page":this.Page}).then((res) => {

        this.KurumBilgisi = res.Data[0];

      });

      this.ActionsGet({"Service":"SatDosya/"+this.satdosyaId, "Page":this.Page}).then((res) => {
              this.Ihalekomisyonkararitarihi=res.Data.Ihalekomisyonkararitarihi;
              this.Ihalekomisyonkarari=res.Data.Ihalekomisyonkarari;
              this.Dokumansatinalanlarinsayisi=res.Data.Dokumansatinalanlarinsayisi;

              let Alimturu=res.Data.Alimturu;

                    this.ActionsSabitGet(1548).then(res => {  
                        for(var i=0; i<res.Data.length; i++)
                        {

                          if (Alimturu==res.Data[i].Id){
                           
                              this.alim_turu=res.Data[i].Value;

                              if (this.alim_turu=="Mal")
                              {this.dipnot1=dipnot1+"M";} 
                              else if (this.alim_turu=="Hizmet"){
                                  this.dipnot1=dipnot1+"H";
                              }

                          }
                         
                        }    
                    }); 

                let ihaleusulu = res.Data.Ihaleturu;

                  this.ActionsSabitGet(1552).then(res => {  
                        for( var i=0; i<res.Data.length; i++)
                        {

                          if (ihaleusulu==res.Data[i].Id){
                           
                              this.ihale_usulu=res.Data[i].Value;
                          }
                         
                        }    
                    }); 

            });


      this.ActionsFilterGet({"Service":"SatOnayBelgesi", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
        if (res.Data.length>0){
            this.OnayBelgesi = res.Data[0];
            let harcamaid=this.OnayBelgesi.Harcamaid;
           

            this.ActionsGet({"Service":"OPersonel/"+harcamaid, "Page":this.Page}).then((res2) => {
             
               this.harcamayetkilisi=res2.Data;

            });

        }
      
      });


        this.ActionsFilterGet({"Service":"SatDosyaIhaleKomisyonu", "Page":this.Page,
       "Filter":"&Dosyaid="+this.satdosyaId+"&Asc=Sira"}).then((res) => {

        this.ihale_komisyonu = res.Data;
       });

          this.ActionsFilterGet({"Service":"SatDosyaIhaleIlani", "Page":this.Page,
      "Filter":"&Dosyaid="+this.satdosyaId}).then((res) => {
          this.ihaleilani=res.Data;
    

      });


    }, 

    teklifkontrol(){
        this.ActionsFilterGet({"Service":"satdosyazarfacmakontrol", "Page":this.Page,"Filter":"&Dosyaid="+this.satdosyaId})
        .then((ressatdosyazarfacmakontrol) => {

        if(ressatdosyazarfacmakontrol){

          this.gecersiz_teklifler=[];
          this.gecerli_teklifler=[];

          for (var j=0; j<ressatdosyazarfacmakontrol.Data.length; j++){

                  let istenenbelgeler=(JSON.parse(ressatdosyazarfacmakontrol.Data[j].Istenilenbelgeler));
                
                   // alert(Object.values(istenenbelgeler)[0])
                  let belge_kontrol=0;

                  for (var i=0; i<Object.values(istenenbelgeler).length; i++){

                   
                    if (Object.values(istenenbelgeler)[i]>1){
                        belge_kontrol=1;
                    }
             
                  }

                  let zarffirma="";
                  for (i=0; i<this.dosyafirmalar.length;i++){

                    if (this.dosyafirmalar[i].Id==ressatdosyazarfacmakontrol.Data[j].Dosyafirmaid){
                      zarffirma=this.dosyafirmalar[i].Firmaid;
                    }

                  }


                  if (belge_kontrol==0){

                    this.gecerli_teklifler.push(zarffirma);

                  } else{
                     this.gecersiz_teklifler.push(zarffirma);
                  }


          }

            this.gecerliteklifler();

        }

       });
    },
        

    gecerliteklifler(){

      this.ActionsFilterGet({
          Service: "SatDosyaFirma",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.satdosyaId + "&Firmaturu=3",
          }).then((ressatdosyafirma) => {

            this.katilanfirmalar=ressatdosyafirma.Data.length;
            this.Firma_Toplam=[];

            for (var i=0;i<ressatdosyafirma.Data.length;i++)
            {
              let firmaid=ressatdosyafirma.Data[i].Firmaid;
              let dosyafirmaid=ressatdosyafirma.Data[i].Id;


              // alert(dosyafirmaid)

             var varmi=this.gecerli_teklifler.indexOf(firmaid);
             if (varmi>=0){

                            
              this.ActionsFilterGet({
              Service: "SatDosyaFirmaFiyat/GetEkonomikFiyat",
              Page: this.Page,
              Filter: "&Dosyaid=" + this.satdosyaId +"&TeklifDegerlendirmeYontem=1",
              }).then((ressatdosyafirmafiyat) => {
              

                     this.Firma_Toplam=ressatdosyafirmafiyat.Data.GoturuBedel;
                                              
 
              }); 
            }
            }
          }); 

 
    },




    


    tlCevir(sayi)
        {
            var rakam = sayi.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(",");
            var tamsayi = rakam[0];
            var ondalik = rakam[1]||"";



            var birler = ["","BİR","İKİ","ÜÇ","DÖRT","BEŞ","ALTI","YEDİ","SEKİZ","DOKUZ"];
            var onlar = ["","ON","YİRMİ","OTUZ","KIRK","ELLİ","ALTMIŞ","YETMİŞ","SEKSEN","DOKSAN"];
            var binler = ["","BİN","MİLYON","MİLYAR","TRİLYON","KATRİLYON","KENTİLYON"];
            var sonuc = [];

            var adim = 0;
            for(var i=tamsayi.split(".").length;i>0;i--)
            {
                sayi = tamsayi.split(".")[i-1];
                if(sayi.length==1){ sayi="00"+sayi; }
                if(sayi.length==2){ sayi="0"+sayi; }
                var c="";

                for(var j=1;j<sayi.length+1;j++)
                {
                    if(j==1 && sayi[j-1]==1){ c+= " YÜZ "; }
                    else if(j==1 && birler[sayi[j-1]]!=""){ c+= birler[sayi[j-1]]+" YÜZ "; }
                    else if(j==2){ c+= onlar[sayi[j-1]]+" "; }
                    else if(j==3 && tamsayi.length==5 && sayi[j-1]==1 && adim==1){ c+= " "; }
                    else if(j==3){ c+= birler[sayi[j-1]]+" "; }
                }

                if(c!=""){ sonuc.push(c+binler[adim]); }
                adim++;
            }

            if(sonuc.length!=0){ sonuc = sonuc.reverse().join(" "); }else{ sonuc=""; }
            if(ondalik.length==1){ ondalik=ondalik+"0"; }
            if(ondalik!=""){
                sonuc += " "+onlar[ondalik[0]]+" "+birler[ondalik[1]]+ " KR";
            }

            sonuc = sonuc.replace(/ /g," ").trim();

            return sonuc;
        },

    Export2Word(element, filename = 'Komisyon Kararı'){
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = "</body></html>";
    var html = preHtml+document.getElementById(element).innerHTML+postHtml;

    var blob = new Blob(['\ufeff', html], {
        type: 'application/msword'
    });
    
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    
    // Specify file name
    filename = filename?filename+'.doc':'document.doc';
    
    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);
    
    if(navigator.msSaveOrOpenBlob ){
        navigator.msSaveOrOpenBlob(blob, filename);
    }else{
        // Create a link to the file
        downloadLink.href = url;
        
        // Setting the file name
        downloadLink.download = filename;
        
        //triggering the function
        downloadLink.click();
    }
    
    document.body.removeChild(downloadLink);
        },

     
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="komisyonkarari"
      size="lg"
      title="Komisyon Kararı"
      title-class="font-18"
      hide-footer
    >  

              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                       <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="
                        ExcelExport(
                          'KomisyonKarari',
                          'KomisyonKarari'
                        )
                      "
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                      Excel'e Aktar
                    </button>
     
                    <button
                      type="button"
                      class="btn btn-warning btn-rounded mb-2 me-2"
                      @click="Export2Word('exportContent')" 
                    >
                      <i class="mdi mdi-file-export-outline me-1"></i>
                    Word'e Aktar
                    </button>

     
                  </div>
                </div>
              </div>

   
      
         
<div id="exportContent" ref="content" style="margin-left:10px; " >
<center><strong>İHALE KOMİSYONU KARARI</strong></center>
<br>
 <div style=" margin: 10px" class="table-responsive">
      <table >
          <tbody>
              <tr style="height: 21.5px;">
                <td style="width: 242.5px; height: 21.5px;">İhale kayıt numarası</td>
                <td style="width: 10px; height: 21.5px;">:</td>
                <td style="width: 411px; height: 21.5px;">{{ihaleilani[0].Ihalekayitnumarasi}}</td>
              </tr>
                 <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">Karar No</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;"> 1 </td>
              </tr>
              <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">İdarenin adı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{KurumBilgisi.Kurumadi}}</td>
              </tr>
              <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">İşin adı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{OnayBelgesi.Isintanimi}}</td>
              </tr>
              <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">İhale tarih ve saati</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{ihaleilani[0].Ihaletarihsaati | formatDateTime}}</td>
                </tr>
                <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">İhale Usulü</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{ ihale_usulu}}</td>
                </tr>
                <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">Döküman Satın Alanların Sayısı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{Dokumansatinalanlarinsayisi }}</td>
                </tr>
                 <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">Toplam Teklif Sayısı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{katilanfirmalar}}</td>
                </tr>
                <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">Geçerli Teklif Sayısı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{gecerli_teklifler.length }}</td>
                </tr>
                <tr><td colsan="3"> Ekonomik açıdan en avantajlı teklifin </td></tr>
                <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">a) Sahibinin adı ve soyadı/ticaret unvanı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{Firma_Toplam.Firmaadi1 }}</td>
                </tr>
                <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">b) Tutarı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{ Firma_Toplam.Tutar1 | TrParaFormat}} TL ({{ tlCevir(Firma_Toplam.Tutar1)}} Türk Lirası)</td>
                </tr>
                <tr><td style="width:300px" colsan="3"> Ekonomik açıdan en avantajlı ikinci teklifin </td></tr>
                <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">a) Sahibinin adı ve soyadı/ticaret unvanı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{Firma_Toplam.Firmaadi2 }}</td>
                </tr>
                <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">b) Tutarı</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{ Firma_Toplam.Tutar2 | TrParaFormat}} TL ({{tlCevir(Firma_Toplam.Tutar2)}} Türk Lirası)</td>
                </tr>
              <tr style="height: 21px;">
                <td style="width: 242.5px; height: 21px;">Tutanağın düzenlenme tarih ve saati</td>
                <td style="width: 10px; height: 21px;">:</td>
                <td style="width: 411px; height: 21px;">{{Ihalekomisyonkararitarihi | formatLongDate}}
                  </td>
              </tr>
          </tbody>
      </table>
  </div>


  <p>&nbsp;</p>
<p style="text-align: center;"><strong>İsteklilerin Teklif Ettiği Bedeller</strong></p>
    <div  class="table-responsive">
        <table  style="border: 1px solid; border-collapse: collapse; margin-left:20px; width:96%" border="1" class="table  table-sm table-bordered border-success mb-0">
          <tbody>
          <tr>
          
          <td style="text-align: center;"><strong>İsteklinin Adı/Ticaret Ünvanı</strong></td>
          <td style="width: 105.7px; text-align: center;"><strong>Teklif Ettiği Bedel (TL)</strong></td>
          </tr>
          <tr v-for="Data in Firma_Toplam.IstekliList" :key="Data.Firmaadi"> 
          <td >{{Data.Firmaadi}}</td>
          <td style="text-align:right">{{Data.Tutar | TrParaFormat}} TL</td>

          </tr>

          </tbody>
        </table>

    </div>

    <div style="margin:20px; ">


<p >
{{Ihalekomisyonkarari}}
</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
    </div>



 <div style="margin-left:20px;" >

<table style="width:98%" >
<tbody>
<tr>

<td colspan="6"><center><strong>İhale Komisyonu</strong></center></td>
</tr>
<tr>
  <td colspan="6"><hr></td>
</tr>
  <tr >

          <td v-for="Data in ihale_komisyonu" :key="Data.Id">
            <table>
              <tr>
                <td>
                  <center>
            {{Data.Asilpersonel}}<br>
            {{Data.Gorevi}}<br>
            {{Data.Asilunvan}}
                  </center>
                </td>
       
              </tr>
            </table>

            </td>
        
  </tr>
</tbody>
</table>   
<p>&nbsp;</p>
<p>&nbsp;</p>

</div>    


<div style="margin-left:20px;">
<center><strong>Uygundur</strong></center>
<center><strong>…/11/2021</strong></center>
<p>&nbsp;</p>


<center><strong>{{harcamayetkilisi.Adsoyad}}</strong></center>
<center><strong>{{harcamayetkilisi.Unvanadi}}</strong></center>


<p>&nbsp;</p>
<p>&nbsp;</p>
<p>Eki: Üzerine ihale bırakılan istekli ile varsa ekonomik açıdan en avantajlı ikinci teklif sahibi isteklinin 
  ihalelere katılmaktan yasaklı olmadığına dair teyit belgesi</p>

</div>


</div>         




    </b-modal>
  </Loader>
</template>

<style>

 .a4_dikey {

	width: 20.5cm;
	height: 29cm;
	position: relative;
}
.a4_dikey footer {
	position: absolute;
	bottom: 10px;
	right: 25px;
}

.yazi{

   font-family: Arial, Helvetica, sans-serif;
   font-size: 12px; 
   line-height: 15px;
   
}
    
</style>